import { getProductCategoryPath, getProductPath } from './products';

import { getExperiencePath } from './experience';
import { isDevEnvironment } from '../utils';

/**
 * translateEntryLink
 * Resolves an entry link object from the CMS to a link to the corresponding page in the site
 */
export default function getRoute(target) {
  switch (target?.__typename) {
    case 'ContentfulArticle':
      return `/articles/${target?.slug}`;
    case 'ContentfulDevice':
      return `/devices/${target?.slug}`;
    case 'ContentfulWorkspaceCategory': {
      return `/workspaces/${target.slug}`;
    }
    case 'ContentfulExperience':
      return getExperiencePath(target);
    case 'ContentfulPage':
      return resolvePageTypeLink(target);
    case 'ContentfulWorkspaceSubCategory': {
      let subCategory = target;
      let [parentWorkspaceCategory] = subCategory.workspaceCategory || [];
      if (isDevEnvironment && !parentWorkspaceCategory)
        console.warn(
          `no parent 'workspaceCategory' (query for workspaceCategory: workspace_category in the workspace sub category)`
        );
      let [firstWorkspace] = subCategory.workspaces;
      let categorySlug = parentWorkspaceCategory?.slug;
      let subcategorySlug = subCategory.slug;
      return `/workspaces/${categorySlug}/${subcategorySlug}/${firstWorkspace?.slug}`;
    }
    case 'ContentfulWorkspace': {
      let [parentWorkspaceSubCategory] = target.workspaceSubCategory || [];
      let [parentWorkspaceCategory] = parentWorkspaceSubCategory.workspaceCategory || [];
      let categorySlug = parentWorkspaceCategory?.slug;
      let subcategorySlug = parentWorkspaceSubCategory.slug;
      return `/workspaces/${categorySlug}/${subcategorySlug}/${target?.slug}`;
    }
    case 'ContentfulRichTextDefinition':
      return 'richTextDefinition';
    case 'ContentfulProduct':
      return getProductPath(target);
    case 'ContentfulProductCategory':
      return getProductCategoryPath(target);
    default: {
      if (isDevEnvironment)
        console.warn(
          'type',
          target?.__typename,
          `is missing a link translation and will generate an invalid hyperlink (translateEntryLink())`
        );
      return '';
    }
  }
}

/**
 * resolvePageTypeLink
 * Resolves links to entries of type 'Page' in the CMS
 * @param {{slug: string}} target
 * @returns string
 */
function resolvePageTypeLink(target) {
  // link to page type entries from CMS can cause unwanted results. Add page type link resolvers here, default to slug when possible
  return `/${target?.slug || ''}`;
}
